import { Select, SelectProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledSelect = styled(Select)<SelectProps>(() => ({
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#FAAA0A",
  },
}));
